// Technology & Administrative Support options (employer-reported).
// Values are stored verbatim on the job and shown as badges.
export const TECH_ADMIN_OPTIONS = [
  'EHR or electronic documentation system',
  'AI-assisted documentation tools',
  'Billing and claims support',
  'Insurance credentialing assistance',
  'Administrative or scheduling support',
  'Clinical supervision provided',
  'Licensure supervision provided',
  'Crisis or after-hours coverage',
  'Training and continuing education',
  'Company-provided equipment',
  'None provided',
];

// Shown as job-search filters (exclude "None provided" and "Other").
export const TECH_ADMIN_FILTERS = TECH_ADMIN_OPTIONS.filter((o) => o !== 'None provided');

export const TECH_ADMIN_DISCLAIMER =
  'Employer-reported information—candidates should confirm details during the hiring process.';
